import { apiClient, type TariffContractExEntity } from '@/libs/api'

export type FetchTariffContractQuery = {
  tenantKey: string
  contractId: number
}

export const fetchTariffContract = async (
  { tenantKey, contractId }: FetchTariffContractQuery,
  signal?: AbortSignal
): Promise<TariffContractExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .tariff_contracts._id(contractId)
    .$get({ config: { signal } })
  return data
}
